import React from "react";
import "./contact.css";

const methods = [
  {
    icon: "bi-telephone-fill",
    label: "Phone",
    value: "+971 54 479 2905",
    action: "Call Now",
    href: "tel:+971544792905",
    external: false,
  },
  {
    icon: "bi-whatsapp",
    label: "WhatsApp",
    value: "+971 54 479 2905",
    action: "WhatsApp Now",
    href: "https://wa.me/971544792905?text=Hi, I need refrigerated transport in UAE",
    external: true,
  },
  {
    icon: "bi-envelope-fill",
    label: "Email",
    value: "info@chillerfleet.com",
    action: "Send Email",
    href: "mailto:info@chillerfleet.com",
    external: false,
  },
  {
    icon: "bi-geo-alt-fill",
    label: "Location",
    value: "Ras Al Khor Industrial Area 1, Dubai, UAE",
    action: "Get Directions",
    href: "https://maps.google.com/?q=Ras+Al+Khor+Industrial+Area+1,+Dubai,+UAE",
    external: true,
  },
];

const ContactMethods = () => {
  return (
    <section className="contact-methods-section">
      <div className="container">
        <div className="row gy-4">
          {methods.map((method, i) => (
            <div
              key={i}
              className="col-12 col-sm-6 col-lg-3"
              data-aos="fade-up"
              data-aos-delay={i * 100}
              data-aos-duration="1200"
              data-aos-once="true"
            >
              <div className="contact-method-card">
                <div className="contact-method-icon">
                  <i className={`bi ${method.icon}`}></i>
                </div>
                <h3>{method.label}</h3>
                <p>{method.value}</p>
                <a
                  href={method.href}
                  className="mini-btn primary"
                  target={method.external ? "_blank" : undefined}
                  rel={method.external ? "noopener noreferrer" : undefined}
                >
                  {method.action}
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ContactMethods;
